import React from 'react'
import { Box } from '@moonpig/launchpad-components'
import { Region } from '@moonpig/web-core-types'
import { useExperimentBoolean } from '@moonpig/web-core-eppo/browser'
import { styled } from '@moonpig/launchpad-utils'
import { system } from '@moonpig/launchpad-system'
import { BenefitBox } from '../shared/BenefitBox'

const LoginWizardContainer = styled(Box)`
  ${system({
    display: 'flex',
    justifyContent: 'center',
    gap: 6,
    bgcolor: {
      xs: 'colorBackground01',
      md: 'unset',
    },
  })}
`

const LoginWizardFormContainer = styled(Box)`
  ${system({
    bgcolor: 'colorBackground01',
    pt: 13,
    pb: 6,
    px: 13,
    borderRadius: {
      xs: 0,
      md: 16,
    },
    border: { xs: 0, md: 2 },
    borderColor: { md: 'colorBorder03' },
  })}
`

export const LoginWizard: React.FC<
  React.PropsWithChildren<{
    region: Region
  }>
> = props => {
  const { region } = props

  const featureCustomCodeInput = useExperimentBoolean(
    'customer-auth-custom-code-input',
    { fallback: false },
  )

  if (featureCustomCodeInput) {
    return (
      <LoginWizardContainer data-testid="login-wizard-container-v2">
        <LoginWizardFormContainer>
          <Box maxWidth={{ xs: '100%', sm: '416px' }} width={1}>
            {props.children}
          </Box>
        </LoginWizardFormContainer>
      </LoginWizardContainer>
    )
  }

  return (
    <Box
      data-testid="login-wizard-container-v1"
      display="flex"
      mt={{ xs: 0, md: 8 }}
      mb={{ xs: 0, md: 15 }}
      boxShadow={{ xs: 0, md: '0px 1px 4px rgba(0, 32, 77, 0.15)' }}
      borderRadius={{ xs: 0, md: 6 }}
      flexDirection={{ xs: 'column', md: 'row' }}
      bgcolor={{ xs: 'white', md: 'transparent' }}
      overflow="hidden"
    >
      <Box
        bgcolor="white"
        width={{ xs: 1, md: 3 / 5 }}
        py={10}
        pl={{ xs: 5, md: 12 }}
        pr={{ xs: 5, md: 12 }}
        borderRadius={{ xs: 0, md: '16px 0 0 16px' }}
      >
        {props.children}
      </Box>
      <BenefitBox region={region} />
    </Box>
  )
}
